<template>
  <div class="select-owner">
    <div class="type-owner">
      <div class="type-row">
        <div style="width: 125px" class="cell">
          <span>Тип правообл.</span>
        </div>
        <div class="cell">
          <span>Правообладатель</span>
        </div>
        <div class="cell no-border" style="width: 90px">
          <span></span>
        </div>
      </div>
      <!-- <button @click="qwe()">qwe</button> -->
      <div
        class="type-row owner-row"
        v-for="(item, index) in owners"
        :key="'owner_' + index"
      >
        <div class="cell" style="width: 125px">
          <span
            class="type-of-owner"
            @click="showSelectOwner(index)"
          >
            {{
                owners[index].typeOfOwner.code_sp !== undefined &&
                owners[index].typeOfOwner.code_sp !== null &&
                owners[index].typeOfOwner.code_sp !== '' ?
                owners[index].typeOfOwner.code_sp :
                'Выберите тип'
            }}
          </span>
          <TreeComponent v-if="isOwnerTree[index]" :inputData="ownerTypeList" :initOnMount="true" :multiple="false" :selectParent="true" @setSelected="setSelectedTypeOwner($event, index)"></TreeComponent>
          <!-- <v-select
            v-model="owners[index].typeOfOwner"
            @input="setOwnerType($event, index)"
            class="table-select"
            :options="ownerTypeList"
            placeholder="Выберите"
            :reduce="(ownerType) => ownerType.code"
          >
            <span slot="no-options">Не найдено совпадений</span>
          </v-select> -->
        </div>
        <!-- выбрать -->
        <div class="cell cell-select-border" v-if="!isCreateOwner[index] && owners[index].typeOfOwner.code_sp_code !== null">
          <v-select
            v-model="owners[index].name"
            @input="setOwnerData($event, index)"
            class="table-select"
            :options="ownerLists[index]"
            placeholder="Выберите"
            :reduce="(owner) => owner.code"
            @search:focus="selectSearch(index)"
            @search="fetchOptions"
          >
            <span slot="no-options">Не найдено совпадений</span>
          </v-select>
          <!-- <v-select
            v-else
            v-model="owners[index].name"
            @input="setOwnerData($event, index)"
            class="table-select"
            :options="ownerLists[index]"
            placeholder="Выберите"
            :reduce="(owner) => owner.code"
            @search:focus="selectSearch(index)"
            @search="fetchOptions"
          >
            <span slot="no-options">Не найдено совпадений</span>
          </v-select> -->
        </div>
        <!-- создать -->
        <div class="cell cell-select-border cr-ow" v-else>
          <div class="create-person" v-if="isPersonMix(owners[index].typeOfOwner.code_sp_code)">
            <input type="text" placeholder="Фамилия" v-model="owners[index].lastName">
            <input type="text" placeholder="Имя" v-model="owners[index].firstName">
            <input type="text" placeholder="Отчество" v-model="owners[index].middleName">
            <input type="text" placeholder="ИНН" v-model="owners[index].oid">
            <input type="text" placeholder="Адрес" v-model="owners[index].location.text">
          </div>
          <div class="create-person" v-else-if="isOrganizationMix(owners[index].typeOfOwner.code_sp_code)">
            <input type="text" placeholder="Название организации" v-model="owners[index].name">
            <input type="text" placeholder="Полное название организации" v-model="owners[index].fullName">
            <input type="text" placeholder="ИНН" v-model="owners[index].oid">
            <input type="text" placeholder="ОГРН" v-model="owners[index].ogrn">
            <input type="text" placeholder="Адрес" v-model="owners[index].location.text">
          </div>
          <div class="create-person" v-else>
            <input type="text" placeholder="Название организации" v-model="owners[index].name">
            <input type="text" placeholder="ИНН" v-model="owners[index].oid">
            <input type="text" placeholder="Адрес" v-model="owners[index].location.text">
          </div>
        </div>
        <div class="cell no-border" style="width: 90px">
          <!-- чекбокс меняет выбрать владельца или создать -->
          <div class="custom-wrapper">
            <div class="filter-check">
              <div class="input-wrap">
                <label>
                  <input v-model="isCreateOwner[index]" type="checkbox" hidden>
                  <span>{{ owners[index].name ? 'Редактировать правообладателя' : 'Новый правообладатель'}}</span>
                </label>
              </div>
            </div>
            <button @click="delItem(index, 'owner')" class="">
              <img src="@img/close.svg" alt="">
            </button>
          </div>
        </div>
      </div>
    </div>
    <button @click="addItem('owner')" class="btn btn-add">
      <span>+</span>
      Добавить правообладателя
    </button>
    <button @click="acceptOwners()" class="btn accent-btn accept-btn">Выбрать</button>
  </div>
</template>

<script>
import gql from 'graphql-tag'
import TreeComponent from './tree/TreeComponent.vue'

const GET_OWNER_LIST = gql`
query ownerList($sp_Code: String, $search: String) {
  ownerList(first: 10, sp_Code: $sp_Code, search: $search) {
    edges {
      node {
        pk
        name
        oid
        sp {
          code
        }
        person {
          id
          lastName
          middleName
          firstName
        }
        # organizationSet {
        #   edges {
        #     node {
        #       name
        #       fullName
        #       ogrn
        #     }
        #   }
        # }
        organization {
          name
          fullName
          ogrn
        }
        governance {
          name
        }
      }
    }
  }
}
`

export default {
  name: 'select-owner',
  props: ['initData'],
  components: {
    TreeComponent
  },
  data () {
    return {
      searchTimer: null,
      isOwnerTree: [],
      ownerLists: [ // массив из результатов поиска(один элемент - одна строка)
      ],
      owners: [
        {
          typeOfOwner: {
            code_sp_code: null,
            code_sp: ''
          },
          oid: null,
          location: {
            text: null
          }
        }
      ],
      ownersCopy: [],
      isCreateOwner: [
        false
      ],
      selectedIndex: -1
    }
  },
  computed: {
    ownerTypeList () {
      return this.createTreeListMix(this.$store.getters.RIGHT_OWNER_GOVERNANCE_SP_LIST)
    }
  },
  watch: {
    /* owners (newVal) {
      this.$emit('changeOwners', newVal)
    }, */
    initData (newVal) {
      if (newVal !== undefined && newVal !== null) {
        this.isOwnerTree = []
        this.owners = newVal.slice()
        newVal.forEach(item => {
          this.ownerLists.push([])
          this.isCreateOwner.push(false)
          this.isOwnerTree.push(false)
        })
        this.$emit('changeOwners', newVal)
      }
    }
  },
  methods: {
    qwe () {
      console.log(this.owners)
    },

    setSelectedTypeOwner (e, i) {
      if (e.fullInfo.length > 0) {
        this.owners[i].typeOfOwner.text = e.fullInfo[0].text
        this.setOwnerType(e, i)
        this.showSelectOwner(i)
      }
      this.ownerLists = []
    },

    acceptOwners () {
      this.owners.forEach(own => {
        if (this.isPersonMix(own.typeOfOwner.code_sp_code)) {
          own.name = ''
          if (own.lastName !== null) {
            own.name = own.lastName + ' '
          }
          if (own.firstName !== null) {
            own.name += own.firstName + ' '
          }
          if (own.middleName !== null) {
            own.name += own.middleName
          }
        }
      })
      this.ownersCopy = this.owners
      // console.log(this.owners)
      this.$emit('changeOwners', JSON.parse(JSON.stringify(this.ownersCopy)))
      this.closePopup()
    },

    closePopup () {
      this.$emit('closePopup')
    },

    showSelectOwner (i) {
      this.$set(this.isOwnerTree, i, !this.isOwnerTree[i])
    },
    setOwnerType (e, i) {
      if (this.isPersonMix(e.fullInfo[0].id)) {
        this.$set(this.owners, i, {typeOfOwner: {code_sp_code: e.fullInfo[0].id, code_sp: e.fullInfo[0].text}, name: null, firstName: null, middleName: null, lastName: null, location: {text: null}, oid: null})
      } else if (this.isOrganizationMix(e.fullInfo[0].id)) {
        this.$set(this.owners, i, {typeOfOwner: {code_sp_code: e.fullInfo[0].id, code_sp: e.fullInfo[0].text}, name: null, fullName: null, ogrn: null, location: {text: null}, oid: null})
      } else {
        this.$set(this.owners, i, {typeOfOwner: {code_sp_code: e.fullInfo[0].id, code_sp: e.fullInfo[0].text}, name: null, location: {text: null}, oid: null})
      }
    },

    setOwnerData (e, i) {
      let typeOfOwner = this.owners[i].typeOfOwner
      this.$set(this.owners, i, {typeOfOwner: typeOfOwner, ...e})
    },

    createOwnerList (response, type) {
      if (this.isPersonMix(type)) {
        return this.createPersonList(response.data.ownerList)
      } else if (this.isOrganizationMix(type)) {
        return this.createOrganizationList(response.data.ownerList)
      } else {
        return this.createGovernanceList(response.data.ownerList)
      }
    },

    createSpList (data) {
      let arr = []
      data.edges.forEach(edge => {
        let governance = null
        // if (edge.node.oid !== null && edge.node.governance !== null) {
        if (edge.node.governance !== null) {
          governance = {
            label: null,
            code: {
              location: {
                text: null
              }
            }
          }
          governance.label = edge.node.governance.name
          governance.code.oid = edge.node.oid
          try {
            governance.code.codeSpCode = edge.node.oid
            governance.code.name = edge.node.governance.name
          } catch (error) {
            console.warn('fail set name to owner', error)
          }
        }
        // if (governance !== null) {
        //   let codeDuplicateIndex = arr.findIndex(item => { // поиск дублирующихся кодов
        //     return item.code.oid === governance.code.oid
        //   })
        //   if (codeDuplicateIndex === -1) { // если такого code не найдено, то добавить
        //     arr.push(governance)
        //   }
        // }
        arr.push(governance)
      })
      return arr
    },

    createGovernanceList (data) {
      let arr = []
      data.edges.forEach(edge => {
        let governance = null
        if (edge.node.governance !== null) {
          governance = {
            label: null,
            code: {
              location: {
                text: null
              }
            }
          }
          governance.label = edge.node.governance.name
          governance.code.oid = edge.node.oid
          governance.code.id = edge.node.pk
          try {
            governance.code.codeSpCode = edge.node.oid
            governance.code.name = edge.node.governance.name
          } catch (error) {
            console.warn('fail set name to owner', error)
          }
        }
        if (governance !== null) {
          arr.push(governance)
        }
      })
      return arr
    },

    createPersonList (data) {
      // console.log('data', data)
      let arr = []
      data.edges.forEach(edge => {
        let person = null
        // if (edge.node.person !== null && edge.node.oid !== null) {
        if (edge.node.person !== null) {
          let fio = ''
          fio += (edge.node.person.lastName !== '') ? edge.node.person.lastName : ''
          fio += (edge.node.person.firstName !== '') ? ' ' + edge.node.person.firstName : ''
          fio += (edge.node.person.middleName !== '') ? ' ' + edge.node.person.middleName : ''
          fio += (edge.node.oid !== '' && edge.node.oid !== null) ? ` (${edge.node.oid})` : ''

          person = {
            label: null,
            code: {
              location: {
                text: null
              }
            }
          }
          person.label = fio
          // person.code = edge.node.oid
          person.code.oid = edge.node.oid
          person.code.id = edge.node.pk
          person.code.codeSpCode = edge.node.sp.code
          try {
            person.code.lastName = edge.node.person.lastName
            person.code.firstName = edge.node.person.firstName
            person.code.middleName = edge.node.person.middleName
            person.code.name = edge.node.name
          } catch (error) {
            console.warn('fail set lastName, firstName, middleName. User wiht oid "' + edge.node.oid + '" will be send without name. Error: ', error)
          }
        }
        if (person !== null) {
          arr.push(person)
        }
      })
      return arr
    },

    createOrganizationList (data) {
      let arr = []
      data.edges.forEach(edge => {
        let organization = null
        // if (edge.node.oid !== null && edge.node.organizationSet !== null && edge.node.organizationSet.edges.length > 0 && edge.node.organizationSet.edges[0].node.name !== '') {
        if (edge.node.oid !== null && edge.node.organization !== null && edge.node.organization.name !== '') {
          organization = {
            label: null,
            code: {
              location: {
                text: null
              }
            }
          }
          // organization.label = edge.node.organizationSet.edges[0].node.name
          organization.label = edge.node.organization.name
          organization.code.oid = edge.node.oid
          organization.code.id = edge.node.pk
          try {
            organization.code.codeSpCode = edge.node.oid
            // organization.code.name = edge.node.organizationSet.edges[0].node.name
            // organization.code.fullName = edge.node.organizationSet.edges[0].node.fullName
            // organization.code.ogrn = edge.node.organizationSet.edges[0].node.ogrn
            organization.code.name = edge.node.organization.name
            organization.code.fullName = edge.node.organization.fullName
            organization.code.ogrn = edge.node.organization.ogrn
          } catch (error) {
            console.warn('fail set name to owner', error)
          }
        }
        if (organization !== null) {
          let codeDuplicateIndex = arr.findIndex(item => { // поиск дублирующихся кодов
            return item.code.oid === organization.code.oid
          })
          if (codeDuplicateIndex === -1) { // если такого code не найдено, то добавить
            arr.push(organization)
          }
        }
      })
      return arr
    },

    async getOwnersList (search, selectedType, selectedIndex, loading) {
      let res = await this.$apollo.query({
        query: GET_OWNER_LIST,
        variables: {
          sp_Code: selectedType,
          search: search
        }
      })
      let _list = this.createOwnerList(res, selectedType)
      if (_list !== null) {
        this.$set(this.ownerLists, selectedIndex, _list)
      }
      loading(false)
    },

    selectSearch (index) {
      this.selectedIndex = index
      this.selectedType = this.owners[index].typeOfOwner.code_sp_code
    },

    async fetchOptions (search, loading) {
      if (search === '') {
        return
      }
      if (this.searchTimer !== null) {
        clearTimeout(this.searchTimer)
      }
      let selectedType = this.selectedType
      // console.log(selectedType)
      let selectedIndex = this.selectedIndex
      this.searchTimer = setTimeout(() => {
        loading(true)
        this.getOwnersList(search, selectedType, selectedIndex, loading)
      }, 1000)
    },

    delItem (index) {
      this.owners.splice(index, 1)
      this.ownerLists.splice(index, 1)
      this.isCreateOwner.splice(index, 1)
    },

    addItem () {
      this.owners.push({
        typeOfOwner: {
          code_sp_code: null,
          code_sp: ''
        },
        oid: null,
        location: {
          text: null
        }
      })
      this.ownerLists.push([])
      this.isCreateOwner.push(false)
    },

    createOptions (data) {
      if (data === null) {
        return null
      }
      let options = []
      data.edges.forEach(item => {
        // if (item.node.text !== undefined && item.node.text !== 'undefined') {
        options.push({
          code: item.node.text,
          label: item.node.name
        })
        // }
      })
      return options
    }
  }
}
</script>

<style lang="scss">
.owner-row {
  position: relative;
  .vs__dropdown-menu {
    z-index: 99999;
    background-color: #ffffff;
  }
  .create-owner {
    position: absolute;
    top: 3px;
    left: 2px;
    height: auto;
    border: none!important;
  }
  .cr-ow {
    border-right: 1px solid #e6e6e6;
    border-bottom: 1px solid #e6e6e6;
    border-left: 1px solid #e6e6e6;
    input {
      border-left: none!important;
      border-right: none!important;
      &:last-child {
        border-bottom: none;
      }
    }
  }
  .table-select {
    height: 32px;
    .vs__dropdown-toggle {
      height: 32px;
    }
  }
  .no-border {
    vertical-align: middle;
    button {
      margin-top: 3px;
    }
  }
  .custom-wrapper {
    display: flex;
    span {
      font-family: 'Montserrat_R';
    }
    .input-wrap {
      margin-bottom: 0;
      max-width: none;
    }
    .filter-check {
      text-align: left;
      margin: 0 10px;
      span {
        &:before,
        &:after {
          top: 50%;
          transform: translateY(-50%);
        }
      }
    }
  }
  .type-of-owner {
    position: absolute;
    cursor: pointer;
    padding-top: 5px;
    padding-left: 5px;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-left: 1px solid #e6e6e6;
    border-bottom: 1px solid #e6e6e6;
    transition: .3s;
    &:hover {
      color: #4E53E7
    }
  }
}

.accept-btn {
  padding: 10px 20px;
}

</style>



// WEBPACK FOOTER //
// src/components/SelectOwnerVue.vue